import { createI18n } from 'vue-i18n'
import en from './en.json'
import zhHant from './zh-Hant.json'
import th from "./th.json"
import ja from "./ja.json"
import ko from "./ko.json"
import id from "./id.json"
import it from "./it.json"
import de from "./de.json"
import enGB from "./en-GB.json"
import hi from "./hi.json"

const messages = {
	en,
	th,
	ja,
	ko,
	id,
	it,
	de,
	hi,
	'en-GB': enGB,
	'zh-Hant': zhHant,
}

const i18n = createI18n({
	legacy: false,
	globalInjection: true,
	locale: uni.getLocale(),
	fallbackLocale: 'en',
	messages
})

uni.onLocaleChange(res => {
	i18n.global.locale.value = res.locale;
})

export default i18n;